var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"octadesk-chat-ticket-label"},[_c('span',[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","width":"14","height":"14"}},[_c('use',{attrs:{"xlink:href":"#octadesk-app-icon-ticket"}})]),_vm._v("\n    "+_vm._s(_vm.$t('conversation.ticket'))+" "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }